import React, {useState, useEffect} from 'react';
import styled from "styled-components";
import {UserContext} from "@providers/user";
import {saveRealtorPoll} from "@models/user";
import CircleLoading from "@molecules/lotties/circle_loading";
import Icon from "@atoms/icon";
import StarRatings from "@atoms/star.ratings";
import {isEmpty} from "@helpers/helpers";
import ButtonTransparent from "@atoms/button.transparent";
import Checkbox from "@atoms/checkbox";
import Textarea from "@atoms/textarea";
import ButtonBase from "@atoms/button.base";
import {array_unique} from "@helpers/arrays";
import {StarsCard} from "./contact_content";
import StarIcon from '@icons/star.svg';
import ArrowRightIcon from '@icons/arrow-right.svg';
import InfoIcon from '@icons/info.svg';

const ContactReviews = ({reviewsShow, contactInfo, selectedRate, setReviewsShow, setSelectedRate, setShowActionStatus, setShowLoginWithCallback}) => {
    const userContext = React.useContext(UserContext);
    const [reviews, setReviews] = useState({
        reasons: [],
        stars: selectedRate,
        description: '',
        error: '',
        loading: false,
    });

    useEffect(() => {
        setReviews(state => ({
            ...state,
            ['stars']: selectedRate,
            ['loading']: false
        }))
    }, [selectedRate]);

    const handleSelectRate = (rate) => {
        setReviewsShow(true);
        setSelectedRate(rate);

        setReviews(state => ({
            ...state,
            ['stars']: rate,
            ['loading']: false
        }))
    };

    const handleChanges = (e) => {
        const name = e.target.name;
        const value = e.target.value;

        let reasons = reviews.reasons;
        if (name === 'reasons') {
            if (e.target.checked) {
                reasons.push(value);
            } else {
                delete reasons[reasons.indexOf(value)];
            }

            setReviews(state => ({
                ...state,
                [name]: array_unique(reasons)
            }))
        } else {
            setReviews(state => ({
                ...state,
                [name]: value
            }))
        }
    };

    const handleSubmitReviews = () => {
        const {stars, reasons} = reviews;

        if (!isEmpty(stars) && (stars > 4 || (!isEmpty(reasons) && reasons.length))) {
            if (userContext.check && !userContext.isRealtor) {
                savePoll();
            } else {
                setShowLoginWithCallback(true, () => {
                    setTimeout(() => { // Because it takes a while for the login modal to close, so I have to use setTimeOut to run the callback
                        savePoll()
                    }, 200)
                })
            }

        } else {
            handlePollErrors('لطفا یک مورد رو انتخاب کنید.');
        }
    };

    const handlePollErrors = (error) => {
        setReviews(state => ({
            ...state,
            ['error']: error,
            ['loading']: false
        }));

        setTimeout(() => {
            setReviews(state => ({
                ...state,
                ['error']: ''
            }))
        }, 2000)
    };

    const savePoll = () => {
        const {stars, reasons, description} = reviews;
        const realtor_id = contactInfo.realtor_id;

        setReviews(state => ({
            ...state,
            ['loading']: true
        }));

        saveRealtorPoll(realtor_id, reasons, stars, description).then(result => {
            setShowActionStatus({
                text: 'از اینکه ما رو در شناسایی مشاورهای خوب همراهی می‌کنید، متشکریم.',
                status: 'done',
            });
        }).catch(err => {
            let errorText = 'انگار خطایی رخ داد لطفا دوباره تلاش کنید.';
            let showErrorModal = true;

            if (!isEmpty(err) && !isEmpty(err.response) && !isEmpty(err.response.data) && !isEmpty(err.response.data.errors)) {
                const {errors} = err.response.data;

                if (!isEmpty(errors.user_id)) {
                    errorText = 'چون شما مشاور هستین، نمی‌تونین توی رای مردمی شرکت کنین.';
                } else if (!isEmpty(errors.realtor_id) && !isEmpty(errors.realtor_id[0]) && errors.realtor_id[0] === 'validation:dublicate') {
                    errorText = 'انگار قبلا به این مشاور رای دادین.';
                } else if (!isEmpty(errors.realtor_id) && !isEmpty(errors.realtor_id[0]) && errors.realtor_id[0] === 'validation:exists') {
                    errorText = 'کاربری با این اطلاعات پیدا نشد.';
                } else if (!isEmpty(errors.reasons)) {
                    showErrorModal = false;

                    handlePollErrors('لطفا نظرتون رو وارد کنید.');
                }
            }

            if (showErrorModal) {
                setShowActionStatus({
                    text: errorText,
                    status: 'cancel',
                });
            }
        })
    };

    const reasonsList = [
        {label: 'عدم شناخت بازار', name: 'knowledge'},
        {label: 'عدم پاسخگویی', name: 'unresponsive'},
        {label: 'دریافت کمیسیون اضافی', name: 'commission'},
        {label: 'برخورد نامناسب', name: 'encounter'},
    ];


    return (
        <ReviewBody className={"contact-modal-reviews text-center h-100 " + ((reviewsShow) ? ' show-reviews ' : '') + ((selectedRate > 0 && reviewsShow) ? 'position-relative' : 'position-absolute')}>

            <h3 className="h2">امتیاز به مشاور</h3>

            <Back onClick={() => {
                setReviewsShow(false);
                setSelectedRate(0);

                const starRatings = document.querySelector('.contact-modal-reviews .star-ratings');
                if (!isEmpty(starRatings)) {
                    setTimeout(() => {
                        const stars = starRatings.querySelectorAll('.star');

                        for (let star of stars) {
                            star.classList.remove('active');
                        }
                    }, 600)
                }
            }}>
                <Icon width="16" height="16"><ArrowRightIcon/></Icon>
            </Back>

            {
                !isEmpty(contactInfo) ?
                    <React.Fragment>

                        <div className="px-0 px-md-32 mt-32">
                            <div className=" py-16 bg-info rounded-8 w-100 d-flex align-items-center justify-content-center flex-column">
                                <p> چه امتیازی به {contactInfo.realtor_name} میدین؟</p>
                                <StarsCard className="mt-1">
                                    <StarRatings
                                        default_rate={((selectedRate > 0 && reviewsShow) ? selectedRate : 0)}
                                        icon={<StarIcon/>}
                                        size={22}
                                        onChange={(e) => handleSelectRate(e)}
                                    />
                                </StarsCard>
                            </div>
                        </div>

                        <ReviewItems className="px-0 px-md-32">
                            <div className={"mt-24 w-100 text-right " + (selectedRate < 5 ? 'd-block' : 'd-none')}>
                                <p>دلایل این امتیاز رو انتخاب کنید:</p>

                                {
                                    reasonsList.map((reason, key) =>
                                        <Checkbox
                                            label={reason.label}
                                            name="reasons"
                                            id={reason.name}
                                            value={reason.name}
                                            className="mt-16"
                                            onChange={handleChanges}
                                        />
                                    )
                                }
                            </div>

                            <div className="mt-24 w-100 text-right">
                                <Textarea
                                    name="description"
                                    rows={2}
                                    onChange={handleChanges}
                                    value={reviews.description}
                                    placeholder="نظرتون رو درباره این مشاور بنویسید."
                                    help={<TextareaHint className={"d-flex " + ((!isEmpty(reviews.error) && reviews.error) ? 'text-danger-text' : 'text-primary')}>
                                        <Icon width={16} height={16} className="ml-8"><InfoIcon/></Icon>
                                        {(!isEmpty(reviews.error)) ? reviews.error : 'نظر شما بدون ذکر موبایل برای مدیر این دفتر نمایش داده میشه.'}
                                    </TextareaHint>}
                                />
                            </div>
                        </ReviewItems>

                        <div className="px-0 px-md-32">
                            <ButtonBase
                                color="secondary"
                                onClick={() => handleSubmitReviews()}
                                className="mt-auto "
                                disabled={(reviews.loading)}
                                block>
                                {
                                    (reviews.loading) ?
                                        <CircleLoading width={24} height={24}/>
                                        :
                                        'ثبت نظر'
                                }
                            </ButtonBase>
                        </div>
                    </React.Fragment>
                    : ''

            }
        </ReviewBody>
    );
};

function propsAreEqual(prevProps, nextProps) {
    return prevProps.selectedRate === nextProps.selectedRate;
}

export default React.memo(ContactReviews, propsAreEqual);
// styles

const Back = styled(ButtonTransparent)`
    display: flex;
    position: absolute;
    top: 8px;
    right: 0;
    padding: 0;
    
    .icons { 
        width: 24px;
        max-width: 24px;
    }
`;


const ReviewBody = styled.div`
    background-color: #fff;
    display: flex;
    top: 0;
    bottom: 0;
    left: calc(100% + 50px);
    transition: left 0.4s cubic-bezier(0.27, 0.82, 0.47, 0.9), opacity .4s linear;
    flex-direction: column;
    padding: 0;
    width: 100%;
    height: 100%;
    
    &.show-reviews {
        left: 0;
    }
    
    @media (min-width: ${props => props.theme.screenSmMax}) {
        margin-top: 0;
    }
    
    @media (max-width: ${props => props.theme.screenXsMax}) {
        padding: 0 24px 40px;
    }
    
    ${Back} {
        right: 32px;        
    }
`;

const ReviewItems = styled.div`
    height: auto;
`;

const TextareaHint = styled.span`
    font-size: 11px;
`;
